import { MessageOwner } from 'types';

export interface InitialMessage {
  source: MessageOwner.BOT | MessageOwner.USER;
  content: string;
}

export const INITIAL_MESSAGES: InitialMessage[] = [
  {
    source: MessageOwner.BOT,
    content:
      'Hi! This is a preview of your webchat. Type anything to see a reply.',
  },
  {
    source: MessageOwner.USER,
    content: 'Hello!',
  },
  {
    source: MessageOwner.BOT,
    content:
      'Try tweaking the brand color, title, or logo in the wizard and watch the widget update live.',
  },
];

export const CANNED_REPLIES = [
  'Thanks for your message! This is a preview — replies are mocked.',
  "In preview mode the widget doesn't talk to a real backend. All config changes you make in the wizard appear here instantly.",
  'Try tweaking the brand color, title, or logo in the wizard and watch the widget update live.',
];
